import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class NewslettersResource extends AuthenticatedResource {
  static urlRoot = '/newsletters'

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
